<template>
	<div class="p-20">
		<h1 class="mt-0">
			<svg-icon icon-class="file-upload-solid" />
			{{ $t('manualInvoiceUpload') }}
		</h1>
		<el-card>
			<div class="mb-20">
				<h3>Ik wil uploaden voor:</h3>
				<el-select v-model="selectedParticipant" size="mini" :placeholder="$t('select')">
					<el-option v-for="item in availableParticipants" :key="item.reference" :label="item.name" :value="item.reference"> </el-option>
				</el-select>
				<el-select v-model="selectedLegalEntity" size="mini" :placeholder="$t('select')">
					<el-option v-for="item in availableLegalEntities" :key="item.reference" :label="item.registration_name" :value="item.reference"> </el-option>
				</el-select>
			</div>
			<div>
				<div v-if="currentParticipant !== null" class="container mb-20">
					<input id="file" ref="file" accept="application/zip" type="file" name="file" @change="handleFileChange" />
				</div>
				<div>
					<el-button type="primary" @click="onUpload">
						{{ $t('upload') }}
					</el-button>
				</div>
			</div>
		</el-card>
	</div>
</template>
<script>
import { GET_PARTICIPANT_BY_PERSON, GET_PERSON_BY_EXTERNAL_ID, GET_PARTICIPANTS_BY_USER, GET_LEGAL_ENTITIES } from '@/gql';
import getUserInfo from '@/cognito/getUserInfo';
import axios from 'axios';
import Logging from '@/logging';

export default {
	data() {
		return {
			selectedParticipant: undefined,
			selectedLegalEntity: undefined,
			currentPersonRef: {},
			loggedInUserInfo: {},
			currentParticipant: {},
			currentFile: {},
			currentExternalId: {},
			availableParticipants: [],
			availableLegalEntities: []
		};
	},
	watch: {
		selectedParticipant() {
			this.$apollo
				.query({
					query: GET_LEGAL_ENTITIES,
					variables: {
						participant: this.selectedParticipant
					}
				})
				.then(({ data }) => {
					this.availableLegalEntities = data.legal_entities;
				})
				.catch(err => {
					Logging.error(err);
				});
		}
	},
	created() {
		getUserInfo()
			.then(({ data }) => {
				this.loggedInUserInfo = data;

				this.$apollo
					.query({
						query: GET_PARTICIPANTS_BY_USER,
						variables: {
							externalId: this.loggedInUserInfo.sub,
							license_module: 'CORE'
						}
					})
					.then(({ data }) => {
						this.availableParticipants = data.risolto_participant;
					});

				this.$apollo
					.query({
						query: GET_PERSON_BY_EXTERNAL_ID,
						variables: {
							externalId: this.loggedInUserInfo.sub
						}
					})
					.then(({ data }) => {
						this.currentPersonRef = data.risolto_person[0].reference;

						// 1
						this.$apollo
							.query({
								query: GET_PARTICIPANT_BY_PERSON,
								variables: {
									personRef: this.currentPersonRef
								}
							})
							.then(({ data }) => {
								Logging.log('currentParticipant: ', data.risolto_participant_user[0].participant);
								this.currentParticipant = data.risolto_participant_user[0].participant;
							});
					});
			})
			.catch(e => {
				Logging.error(e);
			});
	},
	methods: {
		handleFileChange(event) {},
		onUpload() {
			const _this = this;
			Logging.log('this.currentFile: ', this.currentFile);
			if (!document.getElementById('file').files[0]) {
				_this.$notify({
					title: _this.$t('somethingWentWrong'),
					message: 'Select a file',
					type: 'error'
				});
				return;
			}
			if (_this.selectedParticipant === undefined) {
				_this.$notify({
					title: _this.$t('somethingWentWrong'),
					message: 'Select a participant',
					type: 'error'
				});
				return;
			}

			const payload = {
				participant: _this.selectedParticipant,
				legalEntity: _this.selectedLegalEntity,
				extension: 'zip'
			};

			axios.post(process.env.VUE_APP_GET_SIGNED_URL_UPLOAD, payload).then(({ data }) => {
				_this.signedUrl = data;

				var oFReader = new FileReader();

				oFReader.onload = function(oFREvent) {
					fetch(_this.signedUrl, {
						method: 'PUT',
						body: document.getElementById('file').files[0]
					})
						.then(({ status }) => {
							if (status !== 200) {
								throw new Error('Something went wrong.');
							} else {
								_this.$notify({
									title: 'OK',
									message: _this.$t('fileUploaded'),
									type: 'success'
								});
							}
						})
						.catch(e => {
							Logging.error('Error: ', e);
							_this.$notify({
								title: _this.$t('somethingWentWrong'),
								message: _this.$t('somethingWentWrong'),
								type: 'error'
							});
						});
				};

				oFReader.readAsDataURL(document.getElementById('file').files[0]);
			});
		}
	}
};
</script>
